export default "__VITE_ASSET__bad0373d__"